
export const featuresEn = {
  // General
  features: 'Features',
  feature: 'Feature',
  featureManagement: 'Feature Management',
  manageFeatures: 'Manage system features and premium access',
  
  // Feature properties
  featureKey: 'Feature Key',
  featureName: 'Feature Name',
  featureDescription: 'Description',
  premiumFeature: 'Premium Feature',
  
  // Actions
  addFeature: 'Add Feature',
  editFeature: 'Edit Feature',
  deleteFeature: 'Delete Feature',
  createFeature: 'Create Feature',
  updateFeature: 'Update Feature',
  
  // Messages
  featureCreated: 'Feature created successfully',
  featureUpdated: 'Feature updated successfully',
  featureDeleted: 'Feature deleted successfully',
  
  // Errors
  errorFetchingFeatures: 'Error fetching features',
  errorCreatingFeature: 'Failed to create feature',
  errorUpdatingFeature: 'Failed to update feature',
  errorDeletingFeature: 'Failed to delete feature',
  
  // Validation
  keyRequired: 'Feature key is required',
  nameRequired: 'Feature name is required',
  keyAlreadyExists: 'This feature key already exists',
  keyInvalidFormat: 'Key must be in snake_case format',
  nameTooShort: 'Feature name must be at least 2 characters',
  nameTooLong: 'Feature name must be less than 100 characters',
  descriptionTooLong: 'Description must be less than 500 characters',
  
  // Tooltips
  featureKeyTooltip: 'Unique identifier for the feature (snake_case)',
  featureNameTooltip: 'Display name for the feature',
  featureDescriptionTooltip: 'Optional description of the feature',
  isPremiumTooltip: 'Whether this feature requires a premium subscription',
  
  // Dialogs
  createNewFeatureDescription: 'Create a new feature for the system',
  editFeatureDescription: 'Edit the selected feature',
  deleteFeatureConfirm: 'Are you sure you want to delete this feature? This action cannot be undone.',
  
  // Access
  accessDenied: 'Access Denied',
  adminAccessRequired: 'Administrator access is required',
  noPermissionToView: 'You do not have permission to view this page',
  
  // Search and filters
  searchFeatures: 'Search features...',
  allFeatures: 'All Features',
  freeFeatures: 'Free Features',
  premiumFeatures: 'Premium Features',
  clearFilters: 'Clear Filters',
  
  // Stats
  totalFeatures: 'Total Features',
  freeCount: 'Free',
  premiumCount: 'Premium',
};
